<template>
  <!-- ページ内容 -->
  <div class="l-page l-page--team-add-user">
    <!-- メインコンテンツエリア -->
    <main class="l-main">
      <breadcrumb :breadcrumb-data="breadcrumbData" />

      <!-- メインコンテンツ: 上段共通エリア -->
      <div class="l-main-head">
        <div class="c-title u-w100p">
          <div class="c-title__text c-title__text--blue u-fs34">
            アカウント詳細
          </div>
        </div>
      </div>
      <div class="l-main-content">
        <account-form
          :target-account="account"
          :features="features"
          :services="services"
          :is-readonly="true"
        />
      </div>
      <!-- /ユーザー情報入力エリア -->
    </main>
    <!-- /メインコンテンツエリア -->
  </div>
  <!-- /ページ内容 -->
</template>

<script>
export default {
  props: {
    breadcrumbData: Array,
    features: Object,
    services: Object,
    account: Object,
  },
  computed: {},
  methods: {},
};
</script>
